export class Service {
  /** @var LoggingService */
  loggingService;

  constructor(loggingService) {
    this.loggingService = loggingService;
  }
}
